export enum IAnalyticsActivityV2Enum {
  StartTime = 'AnalyticsActivityV2.starttime',
  LocalStartTime = 'AnalyticsActivityV2.localstarttime',
  LocalStartDate = 'AnalyticsActivityV2.localStartDate',
  LocalEndTime = 'AnalyticsActivityV2.localendtime',
  LocalEndDate = 'AnalyticsActivityV2.localenddate',
  Count = 'AnalyticsActivityV2.count',
  AppId = 'AnalyticsActivityV2.appid',
  SubscriptionId = 'AnalyticsActivityV2.subscriptionid',
  AverageDailyDuration = 'AnalyticsActivityV2.averageDailyDuration',
  AverageInteractionDuration = 'AnalyticsActivityV2.averageInteractionDuration',
  UserId = 'AnalyticsActivityV2.userid',
  StartTimeDay = 'AnalyticsActivityV2.starttime.day',
  LocalStartTimeDay = 'AnalyticsActivityV2.localstarttime.day',
  LocalStartTimeWeek = 'AnalyticsActivityV2.localstarttime.week',
  DayCount = 'AnalyticsActivityV2.dayCount',
  Id = 'AnalyticsActivityV2.teamId',
  PerUserAvgDuration = 'AnalyticsActivityV2.perUserAvgDuration',
  PerUserAvgCount = 'AnalyticsActivityV2.perUserAvgCount',
  TotalDuration = 'AnalyticsActivityV2.totalDuration',
  MaxDuration = 'AnalyticsActivityV2.maxDuration',
  AverageDailyInteractions = 'AnalyticsActivityV2.averageDailyInteractions',
  AverageWeeklyDuration = 'AnalyticsActivityV2.averageWeeklyDuration',
  AverageWeeklyInteractions = 'AnalyticsActivityV2.averageWeeklyInteractions',
  WeekCount = 'AnalyticsActivityV2.weekCount',
  UserCount = 'AnalyticsActivityV2.userCount',
  PerUserAvgDailyDuration = 'AnalyticsActivityV2.perUserAvgDailyDuration',
  PerUserAvgDailyInteractions = 'AnalyticsActivityV2.perUserAvgDailyInteractions',
  PerUserAvgWeeklyDuration = 'AnalyticsActivityV2.perUserAvgWeeklyDuration',
  PerUserAvgWeeklyInteractions = 'AnalyticsActivityV2.perUserAvgWeeklyInteractions',
  HeatmapSegment = 'AnalyticsActivityV2.heatmapsegment',
  WeekdayIndex = 'AnalyticsActivityV2.weekdayindex',
}
